import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ILog } from '@obvious.tech/constellation'

export const Log = defineEntity('Log', {
  endpoint: 'alarms/api/Log',
  schema: SNoop<ILog>(),
})
